/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { deleteApiSubjectV1Id } from '../fn/subject/delete-api-subject-v-1-id';
import { DeleteApiSubjectV1Id$Params } from '../fn/subject/delete-api-subject-v-1-id';
import { getApiSubjectV1Id$Json } from '../fn/subject/get-api-subject-v-1-id-json';
import { GetApiSubjectV1Id$Json$Params } from '../fn/subject/get-api-subject-v-1-id-json';
import { getApiSubjectV1Id$Plain } from '../fn/subject/get-api-subject-v-1-id-plain';
import { GetApiSubjectV1Id$Plain$Params } from '../fn/subject/get-api-subject-v-1-id-plain';
import { getApiSubjectV1IdAgents$Json } from '../fn/subject/get-api-subject-v-1-id-agents-json';
import { GetApiSubjectV1IdAgents$Json$Params } from '../fn/subject/get-api-subject-v-1-id-agents-json';
import { getApiSubjectV1IdAgents$Plain } from '../fn/subject/get-api-subject-v-1-id-agents-plain';
import { GetApiSubjectV1IdAgents$Plain$Params } from '../fn/subject/get-api-subject-v-1-id-agents-plain';
import { getApiSubjectV1IdCustomers$Json } from '../fn/subject/get-api-subject-v-1-id-customers-json';
import { GetApiSubjectV1IdCustomers$Json$Params } from '../fn/subject/get-api-subject-v-1-id-customers-json';
import { getApiSubjectV1IdCustomers$Plain } from '../fn/subject/get-api-subject-v-1-id-customers-plain';
import { GetApiSubjectV1IdCustomers$Plain$Params } from '../fn/subject/get-api-subject-v-1-id-customers-plain';
import { GetSubjectAgentsResponse } from '../models/get-subject-agents-response';
import { GetSubjectCustomersResponse } from '../models/get-subject-customers-response';
import { GetSubjectsResponse } from '../models/get-subjects-response';
import { patchApiSubjectV1Id$Json } from '../fn/subject/patch-api-subject-v-1-id-json';
import { PatchApiSubjectV1Id$Json$Params } from '../fn/subject/patch-api-subject-v-1-id-json';
import { patchApiSubjectV1Id$Plain } from '../fn/subject/patch-api-subject-v-1-id-plain';
import { PatchApiSubjectV1Id$Plain$Params } from '../fn/subject/patch-api-subject-v-1-id-plain';
import { postApiSubjectCreate$Json } from '../fn/subject/post-api-subject-create-json';
import { PostApiSubjectCreate$Json$Params } from '../fn/subject/post-api-subject-create-json';
import { postApiSubjectCreate$Plain } from '../fn/subject/post-api-subject-create-plain';
import { PostApiSubjectCreate$Plain$Params } from '../fn/subject/post-api-subject-create-plain';
import { postApiSubjectV1$Json } from '../fn/subject/post-api-subject-v-1-json';
import { PostApiSubjectV1$Json$Params } from '../fn/subject/post-api-subject-v-1-json';
import { postApiSubjectV1$Plain } from '../fn/subject/post-api-subject-v-1-plain';
import { PostApiSubjectV1$Plain$Params } from '../fn/subject/post-api-subject-v-1-plain';
import { postApiSubjectV1Export$Json } from '../fn/subject/post-api-subject-v-1-export-json';
import { PostApiSubjectV1Export$Json$Params } from '../fn/subject/post-api-subject-v-1-export-json';
import { postApiSubjectV1Export$Plain } from '../fn/subject/post-api-subject-v-1-export-plain';
import { PostApiSubjectV1Export$Plain$Params } from '../fn/subject/post-api-subject-v-1-export-plain';
import { postApiSubjectV1IdHistory$Json } from '../fn/subject/post-api-subject-v-1-id-history-json';
import { PostApiSubjectV1IdHistory$Json$Params } from '../fn/subject/post-api-subject-v-1-id-history-json';
import { postApiSubjectV1IdHistory$Plain } from '../fn/subject/post-api-subject-v-1-id-history-plain';
import { PostApiSubjectV1IdHistory$Plain$Params } from '../fn/subject/post-api-subject-v-1-id-history-plain';
import { postApiSubjectV1IdHistoryExport$Json } from '../fn/subject/post-api-subject-v-1-id-history-export-json';
import { PostApiSubjectV1IdHistoryExport$Json$Params } from '../fn/subject/post-api-subject-v-1-id-history-export-json';
import { postApiSubjectV1IdHistoryExport$Plain } from '../fn/subject/post-api-subject-v-1-id-history-export-plain';
import { PostApiSubjectV1IdHistoryExport$Plain$Params } from '../fn/subject/post-api-subject-v-1-id-history-export-plain';
import { postApiSubjectV1IdLock } from '../fn/subject/post-api-subject-v-1-id-lock';
import { PostApiSubjectV1IdLock$Params } from '../fn/subject/post-api-subject-v-1-id-lock';
import { postApiSubjectV1IdUnlock } from '../fn/subject/post-api-subject-v-1-id-unlock';
import { PostApiSubjectV1IdUnlock$Params } from '../fn/subject/post-api-subject-v-1-id-unlock';
import { SubjectFieldHistoryResponse } from '../models/subject-field-history-response';
import { SubjectResponse } from '../models/subject-response';

@Injectable({ providedIn: 'root' })
export class SubjectService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getApiSubjectV1Id()` */
  static readonly GetApiSubjectV1IdPath = '/private/v1/subjects/{id}';

  /**
   * Retrieves the details of a subject by its unique identifier (ID).
   *
   * Retrieves the details of a subject by its unique identifier (ID).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiSubjectV1Id$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiSubjectV1Id$Plain$Response(params: GetApiSubjectV1Id$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<SubjectResponse>> {
    return getApiSubjectV1Id$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves the details of a subject by its unique identifier (ID).
   *
   * Retrieves the details of a subject by its unique identifier (ID).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiSubjectV1Id$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiSubjectV1Id$Plain(params: GetApiSubjectV1Id$Plain$Params, context?: HttpContext): Observable<SubjectResponse> {
    return this.getApiSubjectV1Id$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubjectResponse>): SubjectResponse => r.body)
    );
  }

  /**
   * Retrieves the details of a subject by its unique identifier (ID).
   *
   * Retrieves the details of a subject by its unique identifier (ID).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiSubjectV1Id$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiSubjectV1Id$Json$Response(params: GetApiSubjectV1Id$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<SubjectResponse>> {
    return getApiSubjectV1Id$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves the details of a subject by its unique identifier (ID).
   *
   * Retrieves the details of a subject by its unique identifier (ID).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiSubjectV1Id$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiSubjectV1Id$Json(params: GetApiSubjectV1Id$Json$Params, context?: HttpContext): Observable<SubjectResponse> {
    return this.getApiSubjectV1Id$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubjectResponse>): SubjectResponse => r.body)
    );
  }

  /** Path part for operation `deleteApiSubjectV1Id()` */
  static readonly DeleteApiSubjectV1IdPath = '/private/v1/subjects/{id}';

  /**
   * Deletes a subject by its unique identifier (ID).
   *
   * Deletes a subject by its unique identifier (ID).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteApiSubjectV1Id()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteApiSubjectV1Id$Response(params: DeleteApiSubjectV1Id$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteApiSubjectV1Id(this.http, this.rootUrl, params, context);
  }

  /**
   * Deletes a subject by its unique identifier (ID).
   *
   * Deletes a subject by its unique identifier (ID).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteApiSubjectV1Id$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteApiSubjectV1Id(params: DeleteApiSubjectV1Id$Params, context?: HttpContext): Observable<void> {
    return this.deleteApiSubjectV1Id$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `patchApiSubjectV1Id()` */
  static readonly PatchApiSubjectV1IdPath = '/private/v1/subjects/{id}';

  /**
   * Partially updates an existing subject by its unique identifier (ID).
   *
   * Partially updates an existing subject by its unique identifier (ID).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchApiSubjectV1Id$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patchApiSubjectV1Id$Plain$Response(params: PatchApiSubjectV1Id$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<SubjectResponse>> {
    return patchApiSubjectV1Id$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Partially updates an existing subject by its unique identifier (ID).
   *
   * Partially updates an existing subject by its unique identifier (ID).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchApiSubjectV1Id$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patchApiSubjectV1Id$Plain(params: PatchApiSubjectV1Id$Plain$Params, context?: HttpContext): Observable<SubjectResponse> {
    return this.patchApiSubjectV1Id$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubjectResponse>): SubjectResponse => r.body)
    );
  }

  /**
   * Partially updates an existing subject by its unique identifier (ID).
   *
   * Partially updates an existing subject by its unique identifier (ID).
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchApiSubjectV1Id$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patchApiSubjectV1Id$Json$Response(params: PatchApiSubjectV1Id$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<SubjectResponse>> {
    return patchApiSubjectV1Id$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Partially updates an existing subject by its unique identifier (ID).
   *
   * Partially updates an existing subject by its unique identifier (ID).
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `patchApiSubjectV1Id$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  patchApiSubjectV1Id$Json(params: PatchApiSubjectV1Id$Json$Params, context?: HttpContext): Observable<SubjectResponse> {
    return this.patchApiSubjectV1Id$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubjectResponse>): SubjectResponse => r.body)
    );
  }

  /** Path part for operation `getApiSubjectV1IdCustomers()` */
  static readonly GetApiSubjectV1IdCustomersPath = '/private/v1/subjects/{id}/customers';

  /**
   * Fetches all customers associated with a subject by its ID from the database asynchronously.
   *
   * Fetches all customers associated with a subject by its ID from the database asynchronously.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiSubjectV1IdCustomers$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiSubjectV1IdCustomers$Plain$Response(params: GetApiSubjectV1IdCustomers$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetSubjectCustomersResponse>> {
    return getApiSubjectV1IdCustomers$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Fetches all customers associated with a subject by its ID from the database asynchronously.
   *
   * Fetches all customers associated with a subject by its ID from the database asynchronously.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiSubjectV1IdCustomers$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiSubjectV1IdCustomers$Plain(params: GetApiSubjectV1IdCustomers$Plain$Params, context?: HttpContext): Observable<GetSubjectCustomersResponse> {
    return this.getApiSubjectV1IdCustomers$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetSubjectCustomersResponse>): GetSubjectCustomersResponse => r.body)
    );
  }

  /**
   * Fetches all customers associated with a subject by its ID from the database asynchronously.
   *
   * Fetches all customers associated with a subject by its ID from the database asynchronously.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiSubjectV1IdCustomers$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiSubjectV1IdCustomers$Json$Response(params: GetApiSubjectV1IdCustomers$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<GetSubjectCustomersResponse>> {
    return getApiSubjectV1IdCustomers$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Fetches all customers associated with a subject by its ID from the database asynchronously.
   *
   * Fetches all customers associated with a subject by its ID from the database asynchronously.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiSubjectV1IdCustomers$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiSubjectV1IdCustomers$Json(params: GetApiSubjectV1IdCustomers$Json$Params, context?: HttpContext): Observable<GetSubjectCustomersResponse> {
    return this.getApiSubjectV1IdCustomers$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetSubjectCustomersResponse>): GetSubjectCustomersResponse => r.body)
    );
  }

  /** Path part for operation `getApiSubjectV1IdAgents()` */
  static readonly GetApiSubjectV1IdAgentsPath = '/private/v1/subjects/{id}/agents';

  /**
   * Fetches all agents associated with a subject by its ID from the database asynchronously.
   *
   * Fetches all agents associated with a subject by its ID from the database asynchronously.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiSubjectV1IdAgents$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiSubjectV1IdAgents$Plain$Response(params: GetApiSubjectV1IdAgents$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetSubjectAgentsResponse>> {
    return getApiSubjectV1IdAgents$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Fetches all agents associated with a subject by its ID from the database asynchronously.
   *
   * Fetches all agents associated with a subject by its ID from the database asynchronously.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiSubjectV1IdAgents$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiSubjectV1IdAgents$Plain(params: GetApiSubjectV1IdAgents$Plain$Params, context?: HttpContext): Observable<GetSubjectAgentsResponse> {
    return this.getApiSubjectV1IdAgents$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetSubjectAgentsResponse>): GetSubjectAgentsResponse => r.body)
    );
  }

  /**
   * Fetches all agents associated with a subject by its ID from the database asynchronously.
   *
   * Fetches all agents associated with a subject by its ID from the database asynchronously.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getApiSubjectV1IdAgents$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiSubjectV1IdAgents$Json$Response(params: GetApiSubjectV1IdAgents$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<GetSubjectAgentsResponse>> {
    return getApiSubjectV1IdAgents$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Fetches all agents associated with a subject by its ID from the database asynchronously.
   *
   * Fetches all agents associated with a subject by its ID from the database asynchronously.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getApiSubjectV1IdAgents$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getApiSubjectV1IdAgents$Json(params: GetApiSubjectV1IdAgents$Json$Params, context?: HttpContext): Observable<GetSubjectAgentsResponse> {
    return this.getApiSubjectV1IdAgents$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetSubjectAgentsResponse>): GetSubjectAgentsResponse => r.body)
    );
  }

  /** Path part for operation `postApiSubjectV1Export()` */
  static readonly PostApiSubjectV1ExportPath = '/private/v1/subjects/export';

  /**
   * Export subjects to CSV file report.
   *
   * Export subjects to CSV file report.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiSubjectV1Export$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiSubjectV1Export$Plain$Response(params?: PostApiSubjectV1Export$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return postApiSubjectV1Export$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Export subjects to CSV file report.
   *
   * Export subjects to CSV file report.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiSubjectV1Export$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiSubjectV1Export$Plain(params?: PostApiSubjectV1Export$Plain$Params, context?: HttpContext): Observable<Blob> {
    return this.postApiSubjectV1Export$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /**
   * Export subjects to CSV file report.
   *
   * Export subjects to CSV file report.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiSubjectV1Export$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiSubjectV1Export$Json$Response(params?: PostApiSubjectV1Export$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return postApiSubjectV1Export$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Export subjects to CSV file report.
   *
   * Export subjects to CSV file report.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiSubjectV1Export$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiSubjectV1Export$Json(params?: PostApiSubjectV1Export$Json$Params, context?: HttpContext): Observable<Blob> {
    return this.postApiSubjectV1Export$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `postApiSubjectV1IdLock()` */
  static readonly PostApiSubjectV1IdLockPath = '/private/v1/subjects/{id}/lock';

  /**
   * Lock subject by internal ID.
   *
   * Lock subject by internal ID
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiSubjectV1IdLock()` instead.
   *
   * This method doesn't expect any request body.
   */
  postApiSubjectV1IdLock$Response(params: PostApiSubjectV1IdLock$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return postApiSubjectV1IdLock(this.http, this.rootUrl, params, context);
  }

  /**
   * Lock subject by internal ID.
   *
   * Lock subject by internal ID
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiSubjectV1IdLock$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  postApiSubjectV1IdLock(params: PostApiSubjectV1IdLock$Params, context?: HttpContext): Observable<void> {
    return this.postApiSubjectV1IdLock$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `postApiSubjectV1IdUnlock()` */
  static readonly PostApiSubjectV1IdUnlockPath = '/private/v1/subjects/{id}/unlock';

  /**
   * Unlock subject by internal ID.
   *
   * Unlock subject by internal ID
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiSubjectV1IdUnlock()` instead.
   *
   * This method doesn't expect any request body.
   */
  postApiSubjectV1IdUnlock$Response(params: PostApiSubjectV1IdUnlock$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return postApiSubjectV1IdUnlock(this.http, this.rootUrl, params, context);
  }

  /**
   * Unlock subject by internal ID.
   *
   * Unlock subject by internal ID
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiSubjectV1IdUnlock$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  postApiSubjectV1IdUnlock(params: PostApiSubjectV1IdUnlock$Params, context?: HttpContext): Observable<void> {
    return this.postApiSubjectV1IdUnlock$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `postApiSubjectCreate()` */
  static readonly PostApiSubjectCreatePath = '/private/v1/subjects/create';

  /**
   * Creates a new subject.
   *
   * Creates a new subject.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiSubjectCreate$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiSubjectCreate$Plain$Response(params?: PostApiSubjectCreate$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<SubjectResponse>> {
    return postApiSubjectCreate$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new subject.
   *
   * Creates a new subject.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiSubjectCreate$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiSubjectCreate$Plain(params?: PostApiSubjectCreate$Plain$Params, context?: HttpContext): Observable<SubjectResponse> {
    return this.postApiSubjectCreate$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubjectResponse>): SubjectResponse => r.body)
    );
  }

  /**
   * Creates a new subject.
   *
   * Creates a new subject.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiSubjectCreate$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiSubjectCreate$Json$Response(params?: PostApiSubjectCreate$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<SubjectResponse>> {
    return postApiSubjectCreate$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Creates a new subject.
   *
   * Creates a new subject.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiSubjectCreate$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiSubjectCreate$Json(params?: PostApiSubjectCreate$Json$Params, context?: HttpContext): Observable<SubjectResponse> {
    return this.postApiSubjectCreate$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubjectResponse>): SubjectResponse => r.body)
    );
  }

  /** Path part for operation `postApiSubjectV1()` */
  static readonly PostApiSubjectV1Path = '/private/v1/subjects';

  /**
   * Retrieves the list of all subjects with the given filter with pagination.
   *
   * Retrieves the list of all subjects with the given filter with pagination
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiSubjectV1$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiSubjectV1$Plain$Response(params?: PostApiSubjectV1$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<GetSubjectsResponse>> {
    return postApiSubjectV1$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves the list of all subjects with the given filter with pagination.
   *
   * Retrieves the list of all subjects with the given filter with pagination
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiSubjectV1$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiSubjectV1$Plain(params?: PostApiSubjectV1$Plain$Params, context?: HttpContext): Observable<GetSubjectsResponse> {
    return this.postApiSubjectV1$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetSubjectsResponse>): GetSubjectsResponse => r.body)
    );
  }

  /**
   * Retrieves the list of all subjects with the given filter with pagination.
   *
   * Retrieves the list of all subjects with the given filter with pagination
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiSubjectV1$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiSubjectV1$Json$Response(params?: PostApiSubjectV1$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<GetSubjectsResponse>> {
    return postApiSubjectV1$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves the list of all subjects with the given filter with pagination.
   *
   * Retrieves the list of all subjects with the given filter with pagination
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiSubjectV1$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiSubjectV1$Json(params?: PostApiSubjectV1$Json$Params, context?: HttpContext): Observable<GetSubjectsResponse> {
    return this.postApiSubjectV1$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<GetSubjectsResponse>): GetSubjectsResponse => r.body)
    );
  }

  /** Path part for operation `postApiSubjectV1IdHistory()` */
  static readonly PostApiSubjectV1IdHistoryPath = '/private/v1/subjects/{id}/history';

  /**
   * Retrieves the history of changes for a specific subject field.
   *
   * Retrieves the history of changes for a specific subject field.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiSubjectV1IdHistory$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiSubjectV1IdHistory$Plain$Response(params: PostApiSubjectV1IdHistory$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<SubjectFieldHistoryResponse>> {
    return postApiSubjectV1IdHistory$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves the history of changes for a specific subject field.
   *
   * Retrieves the history of changes for a specific subject field.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiSubjectV1IdHistory$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiSubjectV1IdHistory$Plain(params: PostApiSubjectV1IdHistory$Plain$Params, context?: HttpContext): Observable<SubjectFieldHistoryResponse> {
    return this.postApiSubjectV1IdHistory$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubjectFieldHistoryResponse>): SubjectFieldHistoryResponse => r.body)
    );
  }

  /**
   * Retrieves the history of changes for a specific subject field.
   *
   * Retrieves the history of changes for a specific subject field.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiSubjectV1IdHistory$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiSubjectV1IdHistory$Json$Response(params: PostApiSubjectV1IdHistory$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<SubjectFieldHistoryResponse>> {
    return postApiSubjectV1IdHistory$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Retrieves the history of changes for a specific subject field.
   *
   * Retrieves the history of changes for a specific subject field.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiSubjectV1IdHistory$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiSubjectV1IdHistory$Json(params: PostApiSubjectV1IdHistory$Json$Params, context?: HttpContext): Observable<SubjectFieldHistoryResponse> {
    return this.postApiSubjectV1IdHistory$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<SubjectFieldHistoryResponse>): SubjectFieldHistoryResponse => r.body)
    );
  }

  /** Path part for operation `postApiSubjectV1IdHistoryExport()` */
  static readonly PostApiSubjectV1IdHistoryExportPath = '/private/v1/subjects/{id}/history-export';

  /**
   * Export the list of all modification done to the subject with the provided ID.
   *
   * Export the history of changes for a specific subject field.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiSubjectV1IdHistoryExport$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiSubjectV1IdHistoryExport$Plain$Response(params: PostApiSubjectV1IdHistoryExport$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return postApiSubjectV1IdHistoryExport$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * Export the list of all modification done to the subject with the provided ID.
   *
   * Export the history of changes for a specific subject field.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiSubjectV1IdHistoryExport$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiSubjectV1IdHistoryExport$Plain(params: PostApiSubjectV1IdHistoryExport$Plain$Params, context?: HttpContext): Observable<Blob> {
    return this.postApiSubjectV1IdHistoryExport$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /**
   * Export the list of all modification done to the subject with the provided ID.
   *
   * Export the history of changes for a specific subject field.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `postApiSubjectV1IdHistoryExport$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiSubjectV1IdHistoryExport$Json$Response(params: PostApiSubjectV1IdHistoryExport$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return postApiSubjectV1IdHistoryExport$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * Export the list of all modification done to the subject with the provided ID.
   *
   * Export the history of changes for a specific subject field.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `postApiSubjectV1IdHistoryExport$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  postApiSubjectV1IdHistoryExport$Json(params: PostApiSubjectV1IdHistoryExport$Json$Params, context?: HttpContext): Observable<Blob> {
    return this.postApiSubjectV1IdHistoryExport$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

}
